import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('notification', ['data']),

    stateDataNexmo: {
      get () {
        return this.data.nexmo.selected
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'nexmo.selected', value })
      }
    },

    stateDataNexmoText: {
      get () {
        return this.data.nexmo.text
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'nexmo.text', value })
      }
    },

    stateDataOnesignal: {
      get () {
        return this.data.onesignal.selected
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'onesignal.selected', value })
        if (value === false) {
          this.setNotificationDataProperty({ property: 'email.subject_same', value: false })
          this.setNotificationDataProperty({ property: 'email.content_same', value: false })
        }
      }
    },

    stateDataEmail: {
      get () {
        return this.data.email.selected
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'email.selected', value })
      }
    },

    stateDataNotificationHeading: {
      get () {
        return this.data.settings.heading
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'settings.heading', value })
      }
    },

    stateDataNotificationContent: {
      get () {
        return this.data.settings.content
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'settings.content', value })
      }
    },

    stateDataEmailHeading: {
      get () {
        return this.data.email.heading
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'email.heading', value })
      }
    },

    stateDataEmailContent: {
      get () {
        return this.data.email.content
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'email.content', value })
      }
    },

    stateDataEmailSubjectSame: {
      get () {
        return this.data.email.subject_same
      },

      set (value) {
        if (value === true) {
          this.setNotificationDataProperty({property: 'email.heading', value: null})
        }
        this.setNotificationDataProperty({property: 'email.subject_same', value})
      }
    },

    stateDataEmailContentSame: {
      get () {
        return this.data.email.content_same
      },

      set (value) {
        if (value === true) {
          this.setNotificationDataProperty({property: 'email.content', value: null})
        }
        this.setNotificationDataProperty({property: 'email.content_same', value})
      }
    },

    stateDataNotificationLink: {
      get () {
        return this.data.settings.link
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'settings.link', value })
      }
    },

    stateDataNotificationSelectedPackage: {
      get () {
        return this.data.settings.package
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'settings.package', value })
      }
    },

    stateDataNotificationUrl: {
      get () {
        return this.data.settings.link_notification
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'settings.link_notification', value })
        value = !value
        if (!value) {
          this.setNotificationDataProperty({ property: 'settings.package_notification', value })
          this.setNotificationDataProperty({ property: 'settings.response_notification', value })
        }
      }
    },

    stateDataNotificationResponse: {
      get () {
        return this.data.settings.response_notification
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'settings.response_notification', value })
        value = !value
        if (!value) {
          this.setNotificationDataProperty({ property: 'settings.package_notification', value })
          this.setNotificationDataProperty({ property: 'settings.link_notification', value })
        }
      }
    },

    stateDataNotificationPackage: {
      get () {
        return this.data.settings.package_notification
      },

      set (value) {
        this.setNotificationDataProperty({ property: 'settings.package_notification', value })
        value = !value
        if (!value) {
          this.setNotificationDataProperty({ property: 'settings.response_notification', value })
          this.setNotificationDataProperty({ property: 'settings.link_notification', value })
        }
      }
    }
  },

  methods: {
    ...mapActions('notification', ['setNotificationDataProperty'])
  }
}
